import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import { CustomButton, Text } from '../../shared/uiComponents';
import { useCheckPermission } from '../../shared/Helpers/hooks';
import { PlusIcon, SearchIcon } from '../../shared/Assets/svg';
import { Users } from '../../shared/Assets/menuIcons';
import { PRIMARY, TEXT as TEXT_COLOR } from '../../shared/Helpers/colors';
import { PERMISSIONS } from '../../App/constants';
import SearchBar from '../../components/SearchBar';
import { Close } from '../../shared/Assets/svgIcons';

const MobileSearchHeader = () => {
	const navigate = useNavigate();
	const { permissionGranted } = useCheckPermission(PERMISSIONS.CLIENT.CREATE);

	const [searchExpanded, setSearchExpanded] = useState(false);

	const openSearchExpanded = () => setSearchExpanded(true);
	const closeSearchExpanded = () => setSearchExpanded(false);

	const addClientHandler = () => navigate('/clients/new');

	if (searchExpanded) {
		return (
			<div className="clientsMobileHeaderExpanded">
				<SearchBar hasFilter style={{ marginTop: 0 }} />
				<Close onClick={closeSearchExpanded} />
			</div>
		);
	}

	return (
		<div className="clientsMobileHeader">
			<div className="clientsMobileHeaderLeft">
				<div className="clientsMobileHeaderIcon">
					<Users color={PRIMARY.BASE} />
				</div>
				<Text title="Clients" type="pmd" fontWeight="semiBold" color={TEXT_COLOR.PRIMARY} />
			</div>
			<div className="clientsMobileHeaderActions">
				<CustomButton
					iconOnly={<SearchIcon size={20} />}
					buttonType="secondaryGray"
					sizeType="sm"
					onClick={openSearchExpanded}
				/>
				{permissionGranted && (
					<CustomButton iconOnly={<PlusIcon />} buttonType="primary" sizeType="sm" onClick={addClientHandler} />
				)}
			</div>
		</div>
	);
};

export default MobileSearchHeader;
